import { Backend, buildFormData } from '@/_axios';

export default {
  list(projectId, detectionSetId, params) {
    return Backend.get(`/project/${projectId}/detection_set/${detectionSetId}/detections/`,
      { params, cancelDuplicates: true });
  },
  createSamples(projectId, detectionSetId, token, params) {
    return Backend.post(`/project/${projectId}/detection_set/${detectionSetId}/detections/create_samples?token=${token}`, params);
  },
  filters(projectId, detectionSetId) {
    return Backend.get(`/project/${projectId}/detection_set/${detectionSetId}/detections/filters`);
  },
  createData(projectId, detectionSetId) {
    return Backend.get(`/project/${projectId}/detection_set/${detectionSetId}/detections/create`);
  },
  editData(projectId, detectionSetId, id) {
    return Backend.get(`/project/${projectId}/detection_set/${detectionSetId}/detections/${id}/edit`);
  },
  create(projectId, detectionSetId, data) {
    return Backend.post(`/project/${projectId}/detection_set/${detectionSetId}/detections/`, data);
  },
  createSamplesFromIds(projectId, detectionSetId, token, data) {
    return Backend.post(`/project/${projectId}/detection_set/${detectionSetId}/detections/create_samples_from_ids?token=${token}`, data);
  },
  deleteIds(projectId, detectionSetId, data) {
    return Backend.post(`/project/${projectId}/detection_set/${detectionSetId}/detections/delete_ids`, data);
  },
  uploadFiles(projectId, detectionSetId, detectionId, data) {
    const formData = new FormData();
    buildFormData(formData, data);
    return Backend.post(
      `/project/${projectId}/detection_set/${detectionSetId}/detections/${detectionId}/uploadFile`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' }, noForbidden: true }
    );
  },
  uploadJson(projectId, detectionSetId, data) {
    return Backend.post(
      `/project/${projectId}/detection_set/${detectionSetId}/detections/uploadJson`, data
    );
  },
  update(projectId, detectionSetId, data) {
    return Backend.put(`/project/${projectId}/detection_set/${detectionSetId}/detections/${data.id}`, data);
  },
  delete(projectId, detectionSetId, id) {
    return Backend.delete(`/project/${projectId}/detection_set/${detectionSetId}/detections/${id}`);
  },
  fileExists(projectId, detectionSetId, hash) {
    return Backend.get(`/project/${projectId}/detection_set/${detectionSetId}/detections/exists/${hash}`);
  },
};
